export default __webpack_public_path__ + "static/media/login-bg.557d74b7.png";